export default {
  addError (state, error) {
    let errors = Object.assign([], state.errors)
    if (~errors.indexOf(error)) return
    errors.push(error)
    state.errors = errors
  },
  removeErrors (state) {
    let errors = []
    state.errors = errors
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/errors.js